module.exports = statisticals;